import { toOrderCompleteBrazeCustomDomestic } from './converter/DomesticOrderConverter'
import { toOrderCompleteBrazeCustomLeisure } from './converter/LeisureOrderConverter'
import { toOrderCompleteBrazeCustomTrain } from './converter/TrainOrderConverter'
import { toOrderCompleteBrazeCustomBus } from './converter/BusOrderConverter'
import { Category, IBrazeCompositeOrderComplete } from '~/app/braze/brazeCustomLog'
import { OrderCompleteV3Query } from '~/__generated__/app/query/order-complete/order-complete.graphql'
import { OrderDetailsCoupon, ProductTypeCode } from '~/__generated__/__types__'
import { orderPayment, paymentAmountByRatio } from '~/app/kinesis/kinesis-helper'

/**
 * useOrderCompleteBrazeCustomConverter
 * author: juho.chung
 */

// type definitions
export type IConverterBrazeCompositeOrderComplete = Omit<
  IBrazeCompositeOrderComplete,
  'cart_category' | 'cart_category_cnt' | 'cart_package_discount' | 'cart_order_yn'
>

export interface GetBrazeCouponAndPointInfoParams {
  orderDetails: OrderCompleteV3Query['orderDetailsV3']
  coupon?: OrderDetailsCoupon
  price: number
}

// hook
const useOrderCompleteBrazeCustomConverter = function () {
  return {
    toOrderCompleteBrazeCustomDomestic,
    toOrderCompleteBrazeCustomLeisure,
    toOrderCompleteBrazeCustomTrain,
    toOrderCompleteBrazeCustomBus,
  }
}

export const getBrazeOrderCategory = (
  order: OrderCompleteV3Query['orderDetailsV3']['categoryOrders'][number]
): Category => {
  return order.__typename === 'OrderDetailsDomestic'
    ? Category[order.propertyCategory.toUpperCase()]
    : order.__typename === 'OrderDetailsLeisureProduct'
      ? order.items[0].product.productTypeCode === ProductTypeCode.Leisure
        ? Category.LEISURE
        : Category.GIFTCARD
      : order.__typename === 'OrderDetailsTrain'
        ? Category.TRAIN
        : Category.BUS
}

type BrazeCouponAndPointInfo = Pick<
  IBrazeCompositeOrderComplete,
  'CouponID' | 'CouponAmount' | 'PointAmount'
>
export const getOrderCompleteBrazeCouponAndPointInfo = ({
  orderDetails,
  coupon,
  price,
}: GetBrazeCouponAndPointInfoParams): BrazeCouponAndPointInfo => {
  const { amount: CouponAmount = 0 } = coupon || {}
  const couponID = coupon?.coupon?.metaCouponId || coupon?.userCoupon?.resource?.id
  const payment = orderPayment(orderDetails)
  const paymentAmount = paymentAmountByRatio(
    payment.orderAmount,
    price,
    payment.pgAmount,
    payment.pointAmount,
    CouponAmount,
    0
  )
  const data: BrazeCouponAndPointInfo = {
    CouponAmount,
    PointAmount: paymentAmount.itemPointAmount,
  }

  if (couponID) {
    data.CouponID = couponID.toString()
  }
  return data
}

export default useOrderCompleteBrazeCustomConverter
